import {useEffect} from 'react'
import './App.css';

import { AzureMP } from 'react-azure-mp'
import {Container, Row, Col } from 'reactstrap'
import previewPicture from './preview.png'


const preview = false

function App() {
  useEffect(() => {
    document.title = "Livestream Pfarrei St. Vitus Bad Salzschlirf"
  }, []);

  
  if (!preview) {

  return (
      <Container style={{marginTop: '0%', height: '650px'}}>
        <Row style={{alignItems: 'center', justifyContent: 'center'}}>
            <p style={{fontSize: '1.5em'}}><b>Christmette vom 24.12.2020 (22:00 Uhr) aus der Vituskirche in Bad Salzschlirf</b></p>
        </Row>
        <Row style={{alignItems: 'center', justifyContent: 'center'}}>
            <p>Klicken Sie auf den Startpfeil und das Video startet. Die Messe beginnt im Video ab Minute 47:00</p>
        </Row>
        <Row>
            <AzureMP
              src={[{ src: "https://vituskirche-gewc1.streaming.media.azure.net/e2345285-dcef-42b0-8d4b-30588b662060/56086f52-e0dd-4207-8040-ab8164e46e9e.ism/manifest(format=mpd-time-csf)" }]}
            />
        </Row>
        </Container>
  );
  }else {
    return (
      <Container style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
        <Row style={{marginTop: '2%', alignItems: 'center', justifyContent: 'center'}}>
          <Col sm='12'>
            <img style={{height: '700px'}} src={previewPicture}></img>
          </Col>
        </Row>
        
      </Container>
    )
  }
}

export default App;
